import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import axios from "axios";
import { API_URL } from "const/constants";
import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

export default function ChangePassword() {
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prevState) => ({ ...prevState, [name]: value }));
  };
  const [errorMessage, setErrorMessage] = useState(false);
  const [showPassword, setShowPassword] = React.useState({
    current: false,
    new: false,
  });
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const [loading, setLoading] = useState(false);
  // const { token } = useParams();
  const userEmail = localStorage.getItem("userEmail");
  const token = localStorage.getItem("token");
  const handleClickShowPassword = (type) =>
    setShowPassword({ ...showPassword, [type]: !showPassword?.[type] });

  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    const payload = {
      password: data?.password,
      currentPassword: data?.currentPassword,
    };
    axios
      .put(`${API_URL}/change-password`, payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((res) => {
        toast.success("Password changed successfully");
        navigate("/");
        setErrorMessage(false);
        setLoading(false);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.errorMessage ||
            err?.response?.data?.message ||
            "Error changing password"
        );
        setLoading(false);
      });
  };

  const handleValidation = () => {
    if (data.password !== data?.cpassword) {
      setErrorMessage(true);
    } else {
      setErrorMessage(false);
    }
  };
  return (
    <>
      <div className="container mx-auto px-4 dashBody">
        <div className="flex content-center items-center justify-center h-full">
          <div className="w-full lg:w-5/12 px-4">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-app-surface border-0 mt-40">
              <div className="rounded-t mb-0 px-6 py-6">
                <div className="text-center mb-3">
                  <h3 className="text-app-text-muted text-xl font-bold uppercase">
                    Change Password
                  </h3>
                </div>

                <hr className="mt-6 border-b-1 border-app-border" />
              </div>
              <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                <form onSubmit={handleSubmit}>
                  <div className="grid grid-cols-1 mb-6 gap-8">
                    <FormControl variant="outlined" size="small" required>
                      <InputLabel htmlFor="outlined-adornment-password">
                        Current Password
                      </InputLabel>
                      <OutlinedInput
                        type={showPassword?.current ? "text" : "password"}
                        name="currentPassword"
                        onChange={handleInputChange}
                        // onKeyUp={handleValidation}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() => handleClickShowPassword("current")}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword?.current ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="Current Password"
                        required
                      />
                    </FormControl>
                    <FormControl variant="outlined" size="small" required>
                      <InputLabel htmlFor="outlined-adornment-password">New Password</InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-password"
                        type={showPassword?.new ? "text" : "password"}
                        name="password"
                        onChange={handleInputChange}
                        label="New Password"
                        // onKeyUp={handleValidation}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() => handleClickShowPassword("new")}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword?.new ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        }
                        required
                      />
                    </FormControl>

                    {/* <FormControl
                      variant="outlined"
                      size="small"
                      error={errorMessage}
                      required
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        Confirm New Password
                      </InputLabel>
                      <OutlinedInput
                        size="small"
                        type={showPassword ? "text" : "password"}
                        name="cpassword"
                        onKeyUp={handleValidation}
                        onChange={handleInputChange}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="Confirm Password"
                        required
                      />{" "}
                      {errorMessage && (
                        <FormHelperText id="component-error-text">
                          {"Password and Confirm password are not matching."}
                        </FormHelperText>
                      )}
                    </FormControl> */}
                  </div>

                  <div className="text-center mt-6">
                    <Button
                      variant="contained"
                      type="submit"
                      fullWidth
                      disabled={errorMessage}
                      startIcon={
                        loading && (
                          <CircularProgress sx={{ fontSize: 8, color: "white" }} size={16} />
                        )
                      }
                    >
                      Change Password
                    </Button>
                  </div>
                </form>
              </div>
            </div>{" "}
            {/* <div className="flex flex-wrap mt-6 relative">
              <div className="w-full text-center">
                <Link to="/" className="text-slate-200">
                  <small>Already an account? Go back to Login</small>
                </Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
